import { createContext, useContext } from "react"
import type { SnackbarVariant } from "../components/Snackbar/Snackbar"

export interface ShowSnackbarOptions {
  title: string
  description?: string
  variant?: SnackbarVariant
  durationMs?: number
}

export interface SnackbarContextData {
  showSnackbar: (options: ShowSnackbarOptions) => string
  dismissSnackbar: (id?: string) => void
}

export const SnackbarContext = createContext<SnackbarContextData | undefined>(undefined)

export const useSnackbar = (): SnackbarContextData => {
  const context = useContext(SnackbarContext)

  if (!context) {
    throw new Error("useSnackbar must be used within SnackbarProvider.")
  }

  return context
}
